import { render, staticRenderFns } from "./sendCoupon.vue?vue&type=template&id=2172c58a&scoped=true&"
import script from "./sendCoupon.vue?vue&type=script&lang=js&"
export * from "./sendCoupon.vue?vue&type=script&lang=js&"
import style0 from "./sendCoupon.vue?vue&type=style&index=0&id=2172c58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172c58a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2172c58a')) {
      api.createRecord('2172c58a', component.options)
    } else {
      api.reload('2172c58a', component.options)
    }
    module.hot.accept("./sendCoupon.vue?vue&type=template&id=2172c58a&scoped=true&", function () {
      api.rerender('2172c58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ads/user/dialog/sendCoupon.vue"
export default component.exports